import { get } from 'lodash'
import KeycloakAuthenticator from './authenticators/keycloak.authenticator'

// Authenticator instance
const _instances = {}

// Authenticator constants
const AUTHENTICATOR = {
  KEYCLOAK: 'keycloak'
}

/**
 * @returns {string}
 */
const getAuthenticatorName = () => {
  return get(window, 'config.authMode')
}

/**
 * @returns {*}
 */
const getAuthenticator = () => {
  const authenticatorName = getAuthenticatorName()

  if (_instances[authenticatorName]) {
    return _instances[authenticatorName]
  }

  switch (authenticatorName) {
    case AUTHENTICATOR.KEYCLOAK:
      _instances[authenticatorName] = new KeycloakAuthenticator()
      return _instances[authenticatorName]
    default:
      console.error('Invalid authenticator given')
      return null
  }
}

export default { getAuthenticator }
